import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { AccountAndDetailSelectorViewModel } from "src/erp/financial/accounting/components/accountAndDetailSelector/accountAndDetailSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { AttachmentDownloader } from "../attachmentFileDownloader";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import  { CreatePaymentOrderView } from "./createPaymentOrder-view"

export class CreatePaymentOrderViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel, porcessId: string) {
        super(parentViewModel);
        this.loadById(porcessId);
        this.requestAttachments = ObservableArray.create<Attachment>();
        this.creditorAccountAndDetails = new AccountAndDetailSelectorViewModel(this);
        this.debtorAccountAndDetails = new AccountAndDetailSelectorViewModel(this);
        this.attachments = new AttachmentListSelectorViewModel(this);
    }
    
    closePopup(resultCode: string) {
    }

    GetDefaultView(): View <ViewModel> {
        return new CreatePaymentOrderView();
    }

    public getTypeId(): string {
        return "VM-CAC60D7E-D1BB-4285-BAC6-C3A6CAAB59C6"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;    
    public set status(v: number) { this._status = getAsNumber(v); } public get status(): number { return this._status;} private _status: number;
    public set requestId(v: string) { this._requestId = v; } public get requestId(): string { return this._requestId;} private _requestId: string;
    public set orderId(v: string) { this._orderId = v; } public get orderId(): string { return this._orderId;} private _orderId: string;
    public set licesnseId(v: string) { this._licesnseId = v; } public get licesnseId(): string { return this._licesnseId;} private _licesnseId: string;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    public set requestNo(v: string) { this._requestNo = v; } public get requestNo(): string { return this._requestNo;} private _requestNo: string;
    public set orderNo(v: string) { this._orderNo = v; } public get orderNo(): string { return this._orderNo;} private _orderNo: string;
    public set licenseNo(v: string) { this._licenseNo = v; } public get licenseNo(): string { return this._licenseNo;} private _licenseNo: string;
    public set amount(v: number) { this._amount = getAsNumber(v); } public get amount(): number { return this._amount;} private _amount: number;
    public set personName(v: string) { this._personName = v; } public get personName(): string { return this._personName;} private _personName: string;
    public set requestComment(v: string) { this._requestComment = v; } public get requestComment(): string { return this._requestComment;} private _requestComment: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment;} private _orderComment: string;
    public set licenseComment(v: string) { this._licenseComment = v; } public get licenseComment(): string { return this._licenseComment;} private _licenseComment: string;
    public set requestType(v: string) { this._requestType = v; } public get requestType(): string { return this._requestType;} private _requestType: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode;} private _transactionCode: string;
    public set transactionTransferType(v: number) { this._transactionTransferType = getAsNumber(v); } public get transactionTransferType(): number { return this._transactionTransferType;} private _transactionTransferType: number;
    public set transactionId(v: string) { this._transactionId = v; } public get transactionId(): string { return this._transactionId;} private _transactionId: string;
    public set RequestCreationTime(v: moment.Moment) { this._RequestCreationTime = v; } public get RequestCreationTime(): moment.Moment { return this._RequestCreationTime;} private _RequestCreationTime: moment.Moment;
    public set orderCreationTimw(v: moment.Moment) { this._orderCreationTimw = v; } public get orderCreationTimw(): moment.Moment { return this._orderCreationTimw;} private _orderCreationTimw: moment.Moment;
    public set licenseCreationTime(v: moment.Moment) { this._licenseCreationTime = v; } public get licenseCreationTime(): moment.Moment { return this._licenseCreationTime;} private _licenseCreationTime: moment.Moment;
    public set requestAttachments(v: ObservableArray<Attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<Attachment> { return this._requestAttachments;} private _requestAttachments: ObservableArray<Attachment>;
    public set creditorAccountAndDetails(v: AccountAndDetailSelectorViewModel) { this._creditorAccountAndDetails = v; } public get creditorAccountAndDetails(): AccountAndDetailSelectorViewModel { return this._creditorAccountAndDetails;} private _creditorAccountAndDetails: AccountAndDetailSelectorViewModel;
    public set debtorAccountAndDetails(v: AccountAndDetailSelectorViewModel) { this._debtorAccountAndDetails = v; } public get debtorAccountAndDetails(): AccountAndDetailSelectorViewModel { return this._debtorAccountAndDetails;} private _debtorAccountAndDetails: AccountAndDetailSelectorViewModel;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
    
    async loadById(porcessId: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/GetProcessById', {
                Id: porcessId
            });
            this.status = result.Request.Status;
            this.requestId = result.Request.RequestId;
            this.orderId = result.Request.OrderId;
            this.licesnseId = result.Request.LicenseId;
            this.processId = result.Request.ProcessId;
            this.requestNo = result.Request.RequestNo;
            this.orderNo = result.Request.OrderNo;
            this.licenseNo = result.Request.LicenseNo;
            this.amount = result.Request.Amount;
            this.personName = result.Request.PersonName;
            this.requestComment = result.Request.RequestComment;
            this.orderComment = result.Request.OrderComment;
            this.licenseComment = result.Request.LicenseComment;
            this.requestType = result.Request.RequestType;
            this.transactionCode = result.Request.TransactionCode;
            this.transactionTransferType = result.Request.TransactionTransferType;
            this.transactionId = result.Request.TransactionId;
            this.RequestCreationTime = result.Request.RequestCreationTime;
            this.orderCreationTimw = result.Request.OrderCreationTime;
            this.licenseCreationTime = result.Request.LicenseCreationTime;
            this.requestAttachments.update(...result.Request.RequestAttachments.map(p=>{
                let r = new Attachment(this);
                r.name = p.Name;
                r.id = p.Id;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    private getAccountInfo(selector : AccountAndDetailSelectorViewModel){
        if(selector.accountSelector.selectedAccount==null)
            return null;
        return {
            AccountId:selector.accountSelector.selectedAccount.id,
            DetailValues:selector.details.map(q=>{
                return {
                    AccountDetailId:q.assignmentId,
                    ValueId:q.valueSelector.selectedItem.id
                }
            })
        };
    }
    async save() {
        let validationResult: string[] = this.validationInformation();
        if (validationResult.length != 0){
            await this.messageBoxConfirmWarning(validationResult.join('\r\n'), 'خطا');
        }
        else{
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/CreatePaymentOrder',{
                    ProcessId:this.processId,
                    CreditAccount: this.getAccountInfo(this.creditorAccountAndDetails),
                    DebtAccount:this.getAccountInfo(this.debtorAccountAndDetails),
                    Attachments:this.attachments.getAttachments().map(q=>{
                        return {
                            Name:q.name,
                            Data:q.content
                        };
                    })
                });
                if (result.IsSuccessful){
                    await this.messageBoxConfirmSuccess(`دستور با کد ${result.Code} ثبت شد`,'ثبت دستور پرداخت');
                    this.tryClose(false,'yes');
                }else{
                    await this.messageBoxConfirmWarning('خطا در ثبت دستور پرداخت','خطا');
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    closeWindow(message: string) {
        this.tryClose(true, message, 'آیا از بستن صفحه اطمینان دارید؟','خروج');
    }

    validationInformation(): string[] {
        let result: string[] = [];
        if (this.debtorAccountAndDetails.accountSelector.selectedAccount == null) result.push('اطللاعات بدهکار وارد نشده است.');
        if (this.debtorAccountAndDetails.accountSelector.selectedAccount != null && this.debtorAccountAndDetails.details.map(x=>x.valueSelector.selectedItem == null).filter(x=>x == true).length > 0) result.push('مقادیر تفضیل برای بدهکار تنظیم نشده اند.');
        if (this.creditorAccountAndDetails.accountSelector.selectedAccount != null && this.creditorAccountAndDetails.details.map(x=>x.valueSelector.selectedItem == null).filter(x=>x == true).length > 0) result.push('مقادیر تفضیل برای بستانکار تنظیم نشده اند.');
        return result;
    }
}

export class Attachment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.downloader = new AttachmentDownloader();
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set downloader(v: AttachmentDownloader) { this._downloader = v; } public get downloader(): AttachmentDownloader { return this._downloader;} private _downloader: AttachmentDownloader;
}